import {qrcode} from '@deanwu/vue-component-library'
import JsBarcode from 'jsbarcode'

const DPI = (function() {
	const div = document.createElement('div');
	div.style.width = '1in';
	div.style.height = '1in';
	div.style.position = 'absolute';
	div.style.top = '-100%';
	document.body.appendChild(div);

	const dpi = div.offsetWidth;
	document.body.removeChild(div);

	return dpi;
})();

const parseData = async function(str, data) {
	try {
		let list = str.match(/\{\{([a-z]*)\s*([^\{\}\s]+)\s?([^\{\}]*)\}\}/);
		let event = list[1];
		let field = list[2].split('.');
		let config = list[3];

		if (data == 'preview') {
			data = `{{${event}${event ? ' ' : ''}${field.join('.')}}}`;
		} else {
			!function loop(i) {
				if (i >= field.length || !data) return;
				data = data[field[i]];
				loop(++i);
			}(0);
		}

		switch (event) {
		case 'qc':
			let code = data === undefined ? '' : await qrcode.toDataURL(data, {
				width: 300,
				height: 300,
				margin: 0
			});
			let size = config.split('x');
			return `<div style="font-size: 0;"><img title="${data}" src="${code}" style="width: ${size[0]}mm; height: ${size[1]};"></div>`;

		case 'bc':
			let img = new Image();
			JsBarcode(img, data, {
				format: 'CODE128',
				width: 2,
				height: 200,
				margin: 0,
				displayValue: false
			});
			let bcsize = config.split('x');
			return `<div style="height: 100%; font-size: 0;"><img title="${data}" src="${img.getAttribute('src')}" style="width: 100%; height: 100%;"></div>`;

		default:
			return data === undefined ? '--' : data;
		}
	} catch(e) {
		console.warn(e);
		return '';
	}
}

export default {
	install: function(Vue) {
		const app = new Vue();

		Vue.prototype.px2mm = function(px) {
			return (px * 25.4) / DPI;
		}

		Vue.prototype.mm2px = function(mm) {
			return (mm * DPI) / 25.4;
		}

		Vue.prototype.templatePrint = function(data) {
			const loading = this.$loading({
				message: '打印内容生成中...'
			});
			app.request({
				url: '/print/data',
				data,
				success: async ({dataList, sysData, template_content: template}) => {
					if (template) {
						if (data.template_id == 1) {
							template = `
								<div class="print-page flex-column" border="0" style="width: 40mm; height: 30mm; padding: 3mm 2mm 2mm;">
									<div class="flex-grow">{{bc 背贴码管理.背贴码}}</div>
									<div style="margin-top: 1mm; font-size: 10pt; text-align: center;">{{背贴码管理.背贴码}}</div>
								</div>`
						}
						let fieldList = template.match(/\{\{[^\{\}]+\}\}/g) || [];
						let content = '';
			
						for (let i = 0; i < dataList.length; i++) {
							let data = dataList[i];
							let tpl = template;
	
							for (let j = 0; j < fieldList.length; j++) {
								let field = fieldList[j];
								tpl = tpl.replace(new RegExp(field, 'g'), await parseData(field, Object.assign(data, sysData)));
							}
							content += tpl;
						}
						document.body.insertAdjacentHTML('beforeend', `<div class="print-body" style="display: none;">${content}</div>`);
						setTimeout(() => {
							window.print();
						}, 250);
					}
				},
				complete() {
					loading.$loadOver();
				}
			})
		}

		Vue.prototype.parseTemplateEdit = function(template) {
			return template.replace(/<br>/gi, '').replace(/<img.*title="{{([^"]+)}}".*width="(\d+)[^\d"]*".*height="(\d+)[^\d"]*"[^>]*>/gi, (...data) => {
				return `{{${data[1]} ${parseInt(this.px2mm(data[2]).toFixed(1))}x${parseInt(this.px2mm(data[3]).toFixed(1))}}}`;
			});
		}

		Vue.prototype.templatePreview = async function(template, custom) {
			template = this.parseTemplateEdit(template);
			let fieldList = template.match(/\{\{[^\{\}]+\}\}/g) || [];
			for (let i = 0; i < fieldList.length; i++) {
				let field = fieldList[i];
				template = template.replace(new RegExp(field, 'g'), await parseData(field, 'preview'));
			}
			if (custom) return template;
			document.body.insertAdjacentHTML('beforeend', `<div class="print-body" style="display: none;">${template}</div>`);
			setTimeout(() => {
				window.print();
			}, 250);
		}

		/*********打印三方质检码标签（固定38mm x 20mm、居中对齐，同背贴码打印的.print-body链路）**********/
		Vue.prototype.printQcLabels = function(list) {
			list = (list || []).filter(item => item && item.qc_code);
			if (!list.length) return;

			let content = '';
			list.forEach(item => {
				let img = new Image();
				JsBarcode(img, item.qc_code, {
					format: 'CODE128',
					width: 2,
					height: 200,
					margin: 0,
					displayValue: false
				});
				content += `
					<div class="print-page flex-column" border="0" style="width: 38mm; height: 20mm; padding-bottom: 1mm; line-height: 9pt; font-size: 8pt; text-align: center; word-break: break-word;">
						<div class="flex-grow" style="padding: 2mm 1mm .5mm;"><img title="${item.qc_code}" src="${img.getAttribute('src')}" style="width: 100%; height: 100%;"></div>
						<div style="font-weight: bold;">${item.qc_code || ' '}</div>
						<div>${item.imei || ' '}</div>
						<div style="overflow: hidden; white-space: nowrap;">${item.product_info || ' '}</div>
					</div>
				`;
			});
			document.body.insertAdjacentHTML('beforeend', `<div class="print-body" style="display: none;">${content}</div>`);
			setTimeout(() => {
				window.print();
			}, 250);
		}

		window.addEventListener('afterprint', function() { 
			if (document.body.querySelector('.print-body')) {
				document.body.removeChild(document.body.querySelector('.print-body'));
			}
		});
	}
}
